import { INavigation,
  INotification,
  IPermissionsFeatures,
  IRolePermissions,
  IUserRolesListState,
  UserRole,
  UserRolesState } from './types';

const getters = {
  // Getters related to user roles
  getUserRolesListState(state: UserRolesState): IUserRolesListState {
    return state.roles.userRolesListComponentsState;
  },
  getUserRolesNavigationConfiguration(state: UserRolesState): INavigation {
    return state.roles.userRoles.navigation;
  },
  getIsLastUserRolesPage(state: UserRolesState): boolean {
    return state.roles.userRoles.navigation.isLastElementsPage;
  },
  getUserRolesList(state: UserRolesState): UserRole[] {
    return state.roles.userRoles.userRolesList;
  },

  // Getters related to all permissions
  getPermissionsFeatures(state: UserRolesState): IPermissionsFeatures[] {
    return state.featuresPermissions;
  },

  // Getters related to permissions of currently selected user roles
  getPermissionsFeaturesOfCurrentlySelectedUserRole(state: UserRolesState): string[] {
    return state.rolePermissions && state.rolePermissions.permissions
      ? state.rolePermissions.permissions : [];
  },
  getCurrentUserRole(state: UserRolesState): IRolePermissions | null {
    return state.rolePermissions;
  },
  getEdition(state: UserRolesState): boolean {
    return state.editing;
  },
  getNotificationIsOpen(state: UserRolesState): boolean {
    return state.notification ? state.notification.isOpen : false;
  },
  getNotification(state: UserRolesState): INotification {
    return state.notification;
  },
  getAddition(state: UserRolesState): boolean {
    return state.addition;
  },
  getTotalUserRoles(state: UserRolesState): number {
    return state.roles.userRoles.total;
  },
  getError(state: UserRolesState): string | undefined {
    return state.error;
  },
  getSelected(state: UserRolesState): UserRole | undefined {
    return state.selected;
  }
};

export default getters;
